import { createAction } from "redux-actions";

const EMPTY_MODAL_STACK = "MODAL_DEPTH/empty_modal_stack";
const PUSH_MODAL_STACK = "MODAL_DEPTH/push_modal_stack";
const POP_MODAL_STACK = "MODAL_DEPTH/pop_modal_stack";

export const emptyModalStack = createAction(EMPTY_MODAL_STACK);
export const pushModalStack = createAction(PUSH_MODAL_STACK);
export const popModalStack = createAction(POP_MODAL_STACK);
